import { Grid, Typography } from "@material-ui/core";
import { FilterList } from "@material-ui/icons";
import SearchBox from "components/SearchBox";
import useText from "constants/text";
import React from "react";
import { Button } from "ui/Button";
import { HeaderContainer } from "../style";
import { HeadProps } from "../types";



// eslint-disable-next-line arrow-body-style
export const Header :React.FC<HeadProps> = ({ title, setSearchTerm, searchTerm, buttonClick, cashQuery, clearFilter}) =>{
  const {text} = useText();
    const handleSearchTerm = (event:any)=>{
        setSearchTerm(event.target.value);
    }
    const handleResset =()=> clearFilter()

  const onClick = ()=> buttonClick(true)
    return (
      // eslint-disable-next-line react/self-closing-comp
      <>
        <HeaderContainer>
          <Grid container spacing={0}>
            <Grid xs={12} md={9}>
              <Typography variant="h2" className="header-title">
                {title}
                {cashQuery?.to && (
                  <span className="span-styled">
                    {` ${cashQuery?.from} - ${cashQuery?.to}`}{" "}
                  </span>
                )}{" "}
                {cashQuery?.to && (
                  <Button color="primary" onClick={handleResset} variant="text" className="button-filter">
                    {text.cash_management.clear_filter}
                  </Button>
                )}
              </Typography>
            </Grid>
            <Grid xs={12} md={3}>
              <div className="header-left-container">
                <SearchBox
                  onChange={handleSearchTerm}
                  value={searchTerm}
                  css={`
                    .MuiInputBase-input {
                      height: 1rem;
                    }
                  `}
                />
                <Button className="filter-button" variant="contained" onClick={onClick} endIcon={<FilterList />}>
                  {text.all.filter}
                </Button>
              </div>
            </Grid>
          </Grid>
        </HeaderContainer>
      </>
    );
}